import { connect } from 'react-redux'
import { selectors as authSelectors } from '../../../lifecycle/auth'
import builtInSelectors from '../selectors'
import { AppState, Dispatch } from '../../../types'
import BuiltInDashboardLandingPage, { ValueProps, EventProps } from './BuiltInDashboardLandingPage'
import {
  selectEnvironmentAndFetchAllResources,
  selectResourceAndFetchVersions
} from '../../../common/selector/actions'
import { builtInLPOriginOptions } from '../model'
import { selectVersion } from '../../../common/version/actions'
import { API, Environment } from '../../../remote-api/models'
import { Resource } from '../../../common/resource/model'
import { checkBuiltInDashboardsState, viewBuiltInDashboards } from './actions'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'

const mapProps = (state: AppState): ValueProps => ({
  organizationId: authSelectors.getOrganizationId(state),
  environmentSelector: builtInSelectors.landingPage.environmentSelector.getAll(state),
  resourceSelector: builtInSelectors.landingPage.resourceSelector.getAll(state),
  versionSelector: builtInSelectors.landingPage.versionSelector.getAll(state),
  isTitanium: authSelectors.isMonitoringCenterPremium(state)
})

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  checkBuiltInDashboardsState: () =>
    dispatch(checkBuiltInDashboardsState()),
  environmentSelected: (environmentId: string, environments?: Environment[]) =>
    dispatch(selectEnvironmentAndFetchAllResources({...builtInLPOriginOptions, withMetrics: true}, environmentId, environments)),
  resourceSelected: (resourceId: string, resourceType: ResourceType, resources?: Resource[]) =>
    dispatch(selectResourceAndFetchVersions({...builtInLPOriginOptions, resourceType}, resourceId, resources)),
  versionSelected: (versionId: string, versions: API[]) =>
    dispatch(selectVersion(builtInLPOriginOptions, versions, versionId)),
  onView: (orgId: string, envId: string, resourceId: string, versionId?: string) =>
    dispatch(viewBuiltInDashboards(orgId, envId, resourceId, versionId)),
})

export default connect(mapProps, mapDispatch)(BuiltInDashboardLandingPage)
